'use client';

import { useForm } from 'react-hook-form';

import { Button, Input } from '@components/Form';
import { useRouter } from '@lib/navigation';

interface SearchFormLabels {
  search: string;
  submit: string;
}

interface SearchFormProps {
  labels: SearchFormLabels;
  sortBy?: string;
  defaultValue?: string;
}

export default function SearchForm({
  labels,
  sortBy,
  defaultValue,
}: SearchFormProps) {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
  } = useForm<{ search: string }>({ defaultValues: { search: defaultValue } });
  const router = useRouter();

  const onSubmit = handleSubmit((data) => {
    router.push(`/search?q=${data.search}&sortBy=${sortBy || 'accuracy'}`);
  });

  return (
    <form
      id="page-search"
      className="flex w-full justify-center"
      onSubmit={onSubmit}
    >
      <Input
        className="mr-2 w-3/4 flex-1"
        placeholder={labels.search}
        {...register('search')}
        disabled={isSubmitting}
      />
      <Button className="w-1/4 flex-1" disabled={isSubmitting}>
        {labels.submit}
      </Button>
    </form>
  );
}
